export const notifications = {
  Direct: "Direct",
  footer: {
    from_the_last_30_days: "from the last 30 days.",
    That_s_all_your_notifications: "That's all your notifications",
  },
  Last_Week: "Last Week",
  Mark_all_as_read: "Mark all as read",
  Notifications: "Notifications",
  Older: "Older",
  Product: "Product",
  Show_unread_only: "Show unread only",
  Today: "Today",
  Yesterday: "Yesterday",
} as const;
